import { Fragment, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Components
import Alert from './components/layout/Alert';
import Layout from './components/layout/Layout';
import PrivateRoute from './components/routing/PrivateRoute';
import ValidateSession from './components/routing/ValidateSession';
import NoMatch from './components/routing/NoMatch';

// Login
import Login from './views/auth/Login';

// Dashboard
import Dashboard from './views/dashboard/Dashboard';

// Sucursales
import Sucursales from './views/sucursales/Sucursales';
import NuevaSucursal from './views/sucursales/NuevaSucursal';
import EditarSucursal from './views/sucursales/EditarSucursal';
import DetallesSucursal from './views/sucursales/DetallesSucursal';

// Empleados
import Empleados from './views/empleados/Empleados';
import NuevoEmpleado from './views/empleados/NuevoEmpleado';
import EditarEmpleado from './views/empleados/EditarEmpleado';
import PerfilEmpleado from './views/empleados/PerfilEmpleado';

// Proveedores
import Proveedores from './views/proveedores/Proveedores';
import NuevoProveedor from './views/proveedores/NuevoProveedor';
import EditarProveedor from './views/proveedores/EditarProveedor';
import PerfilProveedor from './views/proveedores/PerfilProveedor';

// Gastos
import Gastos from './views/gastos/Gastos';

// Eventos
import Eventos from './views/eventos/Eventos';
import NuevoEvento from './views/eventos/NuevoEvento';
import EditarEvento from './views/eventos/EditarEvento';
import DetallesEvento from './views/eventos/DetallesEvento';

// Ventas
import Ventas from './views/ventas/Ventas';
import InformacionVenta from './views/ventas/InformacionVenta';

// Vueltas
import Vueltas from './views/vueltas/Vueltas';
import InformacionVuelta from './views/vueltas/InformacionVuelta';

// Pagos
import Pagos from './views/pagos/Pagos';
import InformacionPago from './views/pagos/InformacionPago';

// Cortes
import Cortes from './views/cortes/Cortes';
import InformacionCorte from './views/cortes/InformacionCorte';

// Nóminas
import Nominas from './views/nominas/Nominas';
import FormularioNomina from './views/nominas/FormularioNomina';

// Revisiones
import Revisiones from './views/revisiones/Revisiones';
import InformacionRevision from './views/revisiones/InformacionRevision';

// Usuarios
import Usuarios from './views/usuarios/Usuarios';

// Reportes
import Reportes from './views/reportes/Reportes';

// Configuración
import Perfil from './views/configuracion/perfil/Perfil';
import Metodos from './views/configuracion/metodos/Metodos';
import Productos from './views/configuracion/productos/Productos';
import NuevoProducto from './views/configuracion/productos/NuevoProducto';
import EditarProducto from './views/configuracion/productos/EditarProducto';

// Redux
import store from './store';
import { loadUser } from './actions/auth';
import setAuthToken from './utils/setAuthToken';

function App() {
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}

	useEffect(() => {
		store.dispatch(loadUser());
	}, []);

	return (
		<Provider store={store}>
			<BrowserRouter>
				<Fragment>
					<Layout></Layout>
					<section className="container-fluid principal-section">
						<Alert></Alert>

						<Routes>
							{/* Login */}
							<Route exact path="/" element={<ValidateSession><Login /></ValidateSession>}/>
							<Route exact path="/login" element={<ValidateSession><Login /></ValidateSession>}/>

							{/* Dashboard */}
							<Route path="/dashboard" element={<PrivateRoute routePermission=''><Dashboard /></PrivateRoute>}/>
							
							{/* Sucursales */}
							<Route path="/sucursales" element={<PrivateRoute routePermission='sucursales.ver'><Sucursales /></PrivateRoute>}/>
							<Route path="/sucursales/nuevo" element={<PrivateRoute routePermission='sucursales.agregar'><NuevaSucursal /></PrivateRoute>}/>
							<Route path="/sucursales/editar/:id" element={<PrivateRoute routePermission='sucursales.editar'><EditarSucursal /></PrivateRoute>}/>
							<Route path="/sucursales/detalles/:id" element={<PrivateRoute routePermission='sucursales.detalles'><DetallesSucursal /></PrivateRoute>}/>

							{/* Empleados */}
							<Route path="/empleados" element={<PrivateRoute routePermission='empleados.ver'><Empleados /></PrivateRoute>}/>
							<Route path="/empleados/nuevo" element={<PrivateRoute routePermission='empleados.agregar'><NuevoEmpleado /></PrivateRoute>}/>
							<Route path="/empleados/editar/:id" element={<PrivateRoute routePermission='empleados.editar'><EditarEmpleado /></PrivateRoute>}/>
							<Route path="/empleados/perfil/:id" element={<PrivateRoute routePermission='empleados.perfil'><PerfilEmpleado /></PrivateRoute>}/>

							{/* Proveedores */}
							<Route path="/proveedores" element={<PrivateRoute routePermission='proveedores.ver'><Proveedores /></PrivateRoute>}/>
							<Route path="/proveedores/nuevo" element={<PrivateRoute routePermission='proveedores.agregar'><NuevoProveedor /></PrivateRoute>}/>
							<Route path="/proveedores/editar/:id" element={<PrivateRoute routePermission='proveedores.editar'><EditarProveedor /></PrivateRoute>}/>
							<Route path="/proveedores/perfil/:id" element={<PrivateRoute routePermission='proveedores.perfil'><PerfilProveedor /></PrivateRoute>}/>

							{/* Gastos */}
							<Route path="/gastos" element={<PrivateRoute routePermission='gastos.ver'><Gastos /></PrivateRoute>}/>

							{/* Eventos */}
							<Route path="/eventos" element={<PrivateRoute routePermission='eventos.ver'><Eventos /></PrivateRoute>}/>
							<Route path="/eventos/nuevo" element={<PrivateRoute routePermission='eventos.agregar'><NuevoEvento /></PrivateRoute>}/>
							<Route path="/eventos/editar/:id" element={<PrivateRoute routePermission='eventos.editar'><EditarEvento /></PrivateRoute>}/>
							<Route path="/eventos/detalles/:id" element={<PrivateRoute routePermission='eventos.ver'><DetallesEvento /></PrivateRoute>}/>

							{/* Ventas */}
							<Route path="/ventas" element={<PrivateRoute routePermission='ventas.ver'><Ventas /></PrivateRoute>}/>
							<Route path="/ventas/informacion/:id" element={<PrivateRoute routePermission='ventas.ver'><InformacionVenta /></PrivateRoute>}/>

							{/* Vueltas */}
							<Route path="/vueltas" element={<PrivateRoute routePermission='vueltas.ver'><Vueltas /></PrivateRoute>}/>
							<Route path="/vueltas/informacion/:id" element={<PrivateRoute routePermission='vueltas.ver'><InformacionVuelta /></PrivateRoute>}/>

							{/* Pagos */}
							<Route path="/pagos" element={<PrivateRoute routePermission='pagos.ver'><Pagos /></PrivateRoute>}/>
							<Route path="/pagos/informacion/:id" element={<PrivateRoute routePermission='pagos.ver'><InformacionPago /></PrivateRoute>}/>

							{/* Cortes */}
							<Route path="/cortes" element={<PrivateRoute routePermission='cortes.ver'><Cortes /></PrivateRoute>}/>
							<Route path="/cortes/informacion/:id" element={<PrivateRoute routePermission='cortes.ver'><InformacionCorte /></PrivateRoute>}/>

							{/* Nóminas */}
							<Route path="/nominas" element={<PrivateRoute routePermission='nominas.ver'><Nominas /></PrivateRoute>}/>
							<Route path="/nominas/nuevo" element={<PrivateRoute routePermission='nominas.agregar'><FormularioNomina /></PrivateRoute>}/>
							<Route path="/nominas/editar/:id" element={<PrivateRoute routePermission='nominas.editar'><FormularioNomina /></PrivateRoute>}/>

							{/* Revisiones */}
							<Route path="/revisiones" element={<PrivateRoute routePermission='revisiones.ver'><Revisiones /></PrivateRoute>}/>
							<Route path="/revisiones/informacion/:id" element={<PrivateRoute routePermission='revisiones.ver'><InformacionRevision /></PrivateRoute>}/>

							{/* Reportes */}
							<Route path="/reportes" element={<PrivateRoute routePermission='reportes.ver'><Reportes /></PrivateRoute>}/>

							{/* Usuarios */}
							<Route path="/usuarios" element={<PrivateRoute routePermission='usuarios.ver'><Usuarios /></PrivateRoute>}/>

							{/* Configuración */}
							<Route path="/configuracion/perfil" element={<PrivateRoute routePermission='configuracion.perfil.ver'><Perfil /></PrivateRoute>}/>
							<Route path="/configuracion/metodos" element={<PrivateRoute routePermission='configuracion.metodos.ver'><Metodos /></PrivateRoute>}/>
							<Route path="/configuracion/productos" element={<PrivateRoute routePermission='configuracion.productos.ver'><Productos /></PrivateRoute>}/>
							<Route path="/configuracion/productos/nuevo" element={<PrivateRoute routePermission='configuracion.productos.agregar'><NuevoProducto /></PrivateRoute>}/>
							<Route path="/configuracion/productos/editar/:id" element={<PrivateRoute routePermission='configuracion.productos.editar'><EditarProducto /></PrivateRoute>}/>

							{/* Cuando no matchea con nada*/}
							<Route path="*" element={<NoMatch />}/>
						</Routes>
					</section>
				</Fragment>
			</BrowserRouter>
		</Provider>
	);
}

export default App;